import { ReactNode, useEffect, useRef } from 'react';
import s from './Toast.module.scss';
import { Typography } from '../../typography-voery/Typography';

export type ToastType = 'default' | 'error' | 'success';

export interface ToastItem {
  id: string;
  message: ReactNode;
  type?: ToastType;
  duration?: number;
}

interface ToastProps {
  toasts: ToastItem[];
  onRemove: (id: string) => void;
}

function ToastBubble({ toast, onRemove }: { toast: ToastItem; onRemove: (id: string) => void }) {
  const duration = toast.duration ?? 3000;

  useEffect(() => {
    if (duration === 0) return;
    const timer = setTimeout(() => onRemove(toast.id), duration);
    return () => clearTimeout(timer);
  }, [toast.id, duration, onRemove]);

  return (
    <div
      className={`${s.toast} ${s[`toast--${toast.type ?? 'default'}`]}`}
      onClick={() => onRemove(toast.id)}
    >
      <Typography variant='callout-medium' className={s.message}>{toast.message}</Typography>
    </div>
  );
}

export function Toast({ toasts, onRemove }: ToastProps) {
  return (
    <div className={s.container}>
      {toasts.map((t) => (
        <ToastBubble key={t.id} toast={t} onRemove={onRemove} />
      ))}
    </div>
  );
}
